import { ITypePage } from "./content.interfaces";

export const getIsKids = (role?: string | null): boolean => role === "KIDS";

export const buildContentQueryParams = (
    role?: string | null,
    profileId?: string | number | null,
): string => {
    const isKids = getIsKids(role);
    return new URLSearchParams({
        is_kids: String(isKids),
        ...(profileId ? {profile: String(profileId)} : {}),
    }).toString();
};

export const buildPageQueryParams = (
    params: Partial<ITypePage>
): string => {
    const queryParams: Record<string, string> = {};
    if (params.region) {
        queryParams.region = String(params.region);
    }
    if (params.profile_id) {
        queryParams.profile_id = String(params.profile_id);
    }
    if (params.search) {
        queryParams.search = String(params.search);
    }
    return new URLSearchParams(queryParams).toString();
};

export const buildAllContentQueryParams = (
    params: Partial<ITypePage>
): string => {
    const queryParams = new URLSearchParams({
        page: String(params.page_number ?? 1),
        "rehydrated-pagination": String(params.rehydrated_pagination ?? true),
    });

    const pageFilters = buildPageQueryParams(params);
    if (pageFilters) {
        const extraParams = new URLSearchParams(pageFilters);
        extraParams.forEach((value, key) => {
            queryParams.set(key, value);
        });
    }

    return queryParams.toString();
};

export const buildPageContentQueryParams = (
    params: Partial<ITypePage>
): string => {
    const queryParams = new URLSearchParams({
        page: String(params.page_number ?? 1),
        "rehydrated-pagination": String(params.rehydrated_pagination ?? true),
        video: "false",
        is_kids: String(getIsKids(params.role)),
    });

    if (params.profile_id !== undefined && params.profile_id !== null) {
        queryParams.append("profile_id", String(params.profile_id));
    }

    if (params.region) {
        queryParams.append("region", String(params.region));
    }

    return queryParams.toString();
};
